<template>
    <router-link  class="card-link" :to="{name: 'theme', params: {slug: model.slug}}">
    <li class="card lift-hover">
        <img alt="this.model.name" class="thumbnailImage" :src="`${$rootUrl()}${model.image}`" />

        <div class="text">
            <p class="cardHeader">{{ name }}</p>
            <div class="info">
                <div class="body summary">{{ description.slice(0, 137) }}</div>
            </div>
        </div>
    </li>
    </router-link>
</template>

<script>

export default {
    name: "MedalCard",
    props: {
        model: {}
    },
    computed: {
        name(){
            if (this.model && this.model.name){
                return this.model.name;
            }
        },
        imageName(){
            if (this.model && this.model.image){
                return this.model.image;
            }
        },
        description(){
            if (this.model && this.model.description){
                return this.model.description;
            }
        },
        endpoint(){
            if (this.model && this.model.endpoint){
                return this.model.endpoint;
            }
        },
        // loadedImage(){
        //     return this.importImage(require.context('/images/themes', false, /\.(png|jpe?g|svg)$/));
        // }
    },
    methods: {
        importImage(contextFiles) {
            var requiredFile;
            contextFiles.keys().map((item, index) => {
                if (contextFiles(item).indexOf(this.imageName) !== -1){
                    requiredFile = contextFiles(item);
                }
            });
            return requiredFile;
        },
    },
}
</script>

<style scoped>
.card {
    height: 485px;
}

.summary{
    margin-top: 10px;
    text-overflow: ellipsis;
}

.summary:after {
    content: '…';
}
</style>